import { StreamActions } from '@hotwired/turbo'
import * as Turbo from '@hotwired/turbo'

StreamActions.redirect_to = function () {
  Turbo.visit(this.getAttribute('path') as string)
}
